import { GraphValueType } from '../enums/graphValueType'
import { SalesReportGraphValues } from '../types/salesReportGraphValues'

interface EmptyGraphValues extends SalesReportGraphValues {
  total: number
}

export const getEmptyGraphValues = (): Record<GraphValueType, EmptyGraphValues> => ({
  [GraphValueType.Gross]: {
    paid: 0,
    unpaid: 0,
    total: 0,
  },
  [GraphValueType.Net]: {
    paid: 0,
    unpaid: 0,
    total: 0,
  },
})
